import { Tree } from '../types/Tree';

export const californianTrees: Tree[] = [
  {
    id: 'eucalyptus',
    name: 'Eucalyptus Tree',
    scientificName: 'Eucalyptus globulus',
    description: 'A tall, fast-growing tree native to Australia but commonly found in California parks.',
    imageUrl: '/images/trees/eucalyptus1.jpg.webp',
    leafImageUrl: '/images/trees/eucalyptus_leaves.jpeg',
    characteristics: {
      height: '50-180 feet tall',
      leaves: 'Long, narrow, blue-green leaves that hang down',
      bark: 'Smooth, white or gray bark that peels off in strips',
      smell: 'Strong, medicinal, minty smell'
    },
    ecosystemValue: [
      'Provides shade and windbreak',
      'Fast carbon absorption',
      'Erosion control on slopes'
    ],
    wildlife: {
      birds: [
        { name: 'Red-winged blackbird', imageUrl: '/images/birds/red-winged black bird.jpeg' },
        { name: 'Mourning dove', imageUrl: '/images/birds/mourning dove.jpeg' },
        { name: 'House finch', imageUrl: '/images/birds/house finch.jpeg' }
      ],
      insects: [
        { name: 'Eucalyptus longhorned borer', imageUrl: '/images/insects/eucalyptus_longhorned_borer.avif' },
        { name: 'Eucalyptus weevil', imageUrl: '/images/insects/eucalyptus_weevil.jpeg' }
      ]
    },
    interestingFacts: [
      'The leaves contain eucalyptol oil, which is why they smell so strong',
      'Koalas in Australia eat almost nothing but eucalyptus leaves',
      'The oil is used in cough drops and cleaning products'
    ],
    suggestedQuestions: [
      'Why does eucalyptus smell so strong?',
      'How does the eucalyptus tree help the environment?',
      'What animals depend on eucalyptus trees?',
      'Why do the leaves hang down instead of spreading out?'
    ]
  },
  {
    id: 'oak',
    name: 'California Oak',
    scientificName: 'Quercus agrifolia',
    description: 'A majestic native tree that is the heart of California ecosystems.',
    imageUrl: '/images/trees/Oak1.jpeg',
    leafImageUrl: '/images/trees/oak_leaves.jpeg',
    characteristics: {
      height: '30-80 feet tall',
      leaves: 'Small, oval leaves with spiny edges that stay green year-round',
      bark: 'Dark gray, deeply grooved bark',
      smell: 'Earthy, woody smell, especially after rain'
    },
    ecosystemValue: [
      'Supports over 300 species of wildlife',
      'Acorns feed many animals',
      'Deep roots prevent soil erosion',
      'Creates cool microclimates'
    ],
    wildlife: {
      birds: [
        { name: 'Acorn woodpecker', imageUrl: '/images/birds/acorn woodpecker.jpeg' },
        { name: 'California scrub jay', imageUrl: '/images/birds/california scrub jay.jpeg' },
        { name: 'Wild turkey', imageUrl: '/images/birds/wild turkey.jpeg' }
      ],
      insects: [
        { name: 'Oak moth caterpillar', imageUrl: '/images/insects/oak moth caterpillar.jpeg' },
        { name: 'Oak gall wasp', imageUrl: '/images/insects/gall-wasp.jpeg' }
      ]
    },
    interestingFacts: [
      'One oak tree can produce 10,000 acorns in a good year',
      'Acorn woodpeckers store thousands of acorns in oak bark',
      'Native Americans made flour from acorns',
      'Some California oaks can live over 300 years'
    ],
    suggestedQuestions: [
      'Why are acorns so important to animals?',
      'How do oak trees help other plants grow nearby?',
      'What makes oak trees so strong in storms?',
      'Why do some oaks keep their leaves all year?'
    ]
  },
  {
    id: 'cypress',
    name: 'Monterey Cypress',
    scientificName: 'Cupressus macrocarpa',
    description: 'A wind-sculpted coastal tree that creates dramatic silhouettes.',
    imageUrl: '/images/trees/cypress1',
    leafImageUrl: '/images/trees/cypress_leaves',
    characteristics: {
      height: '40-80 feet tall',
      leaves: 'Small, scale-like leaves that form flat sprays',
      bark: 'Reddish-brown, fibrous bark',
      smell: 'Fresh, piney scent'
    },
    ecosystemValue: [
      'Coastal erosion control',
      'Windbreak for other plants',
      'Habitat for coastal wildlife',
      'Filters salt spray from ocean'
    ],
    wildlife: {
      birds: [
        { name: 'Monarch butterfly', imageUrl: '/images/birds/monarch butterfly.webp' },
        { name: 'Brown pelican', imageUrl: '/images/birds/brown pelican.jpeg' },
        { name: 'Double-crested cormorant', imageUrl: '/images/birds/double created cormorant.jpeg' }
      ],
      insects: [
        { name: 'Cypress bark beetle', imageUrl: '/images/insects/cypress-bark-beetle.webp' },
        { name: 'Cypress scale insect', imageUrl: '/images/insects/cypress scale insect.webp' }
      ]
    },
    interestingFacts: [
      'Naturally grows only in two small areas near Monterey',
      'Wind shapes them into dramatic, twisted forms',
      'Monarch butterflies use them for winter roosting',
      'They can survive in salty, coastal conditions'
    ],
    suggestedQuestions: [
      'Why do cypress trees grow in such interesting shapes?',
      'How do they survive the salty ocean air?',
      'Why do monarch butterflies choose cypress trees?',
      'What happens to the ecosystem if cypress trees disappear?'
    ]
  }
];